import React from "react"
import {FieldGlistGroupProps} from "../../../../../render/glist/glist-group"
import {ColorPalette} from "../../../../../color-coding/color-coding";

// const debug = "FieldExpenseApprovalStatus_GListGroupModern"
const debug = false

export default function FieldExpenseApprovalStatus_GListGroupModern(props:FieldGlistGroupProps) {

    const option = props.field._getOption(props.data.value)

    const groupColor:any = _.get(option, 'color', null)
    const groupName = _.get(option, 'label', props.field.noValueOptionLabel);

    debug && console.log(debug, 'render', groupColor, option)

    const groupNameClasses = Classes("ui5-group-by-text-2", {
        ['text-color-white']: !groupColor,
    });

    const styles = {
        backgroundColor: gd.skin.colors.mainColor({
            colorNumber: groupColor,
            corePalette: ColorPalette.STATUS
        })
    }

    return <div className={groupNameClasses} style={styles}>{groupName}</div>;

}
